import { emitPointHubDiagnostic } from '../diagnostics';
import type { MeetingOrderPointHubDiagnostic } from '../types';

export const processMeetingBookingDraftDiagnostics = (
  diagnostics: MeetingOrderPointHubDiagnostic[],
  eventId: string,
  droppedFields: string[]
): void => {
  const uniqueDiagnostics = new Map<string, MeetingOrderPointHubDiagnostic>();
  diagnostics.forEach((diagnostic) => {
    if (!diagnostic || !diagnostic.code) return;
    const key = [diagnostic.code, diagnostic.fieldKey || ''].join('|');
    if (!uniqueDiagnostics.has(key)) uniqueDiagnostics.set(key, diagnostic);
  });

  uniqueDiagnostics.forEach((diagnostic) => {
    emitPointHubDiagnostic({
      code: diagnostic.code === 'payload_bytes' ? 'component_payload_bytes' : `component_${diagnostic.code}`,
      eventId,
      field: diagnostic.fieldKey,
      count: diagnostic.count,
      bytes: diagnostic.bytes
    });
  });

  Array.from(new Set(droppedFields)).forEach((field) => {
    emitPointHubDiagnostic({
      code: 'schema_extra_field_dropped',
      eventId,
      field
    });
  });
};

export { normalizeMeetingBookingSessionRecommend } from './normalize';
export { measurePointHubPayloadBytes } from './payload';
export { validateMeetingBookingCollectDraft, validateMeetingBookingSessionRecommend } from './validate';
